export const LIVE_TICK_INTERVAL_MS = 500
export const GRAPH_SAMPLE_INTERVAL_MS = 5000
export const GRAPH_WINDOW_MS = 5 * 60 * 1000
export const MAX_SAMPLES = GRAPH_WINDOW_MS / GRAPH_SAMPLE_INTERVAL_MS
export const MEMORY_ALERT_THRESHOLD_BYTES = 512 * 1024 * 1024
export const MEMORY_GRAPH_UPPER_LIMIT = 2048 * 1024 * 1024
export const QUERY_CACHE_UPPER_LIMIT_BYTES = 100 * 1024 * 1024
export const FPS_TARGET = 60
export const FPS_ALERT_THRESHOLD = 30
export const FPS_SAMPLE_WINDOW_MS = 1000
export const COLLAPSED_WIDTH = '48px'
export const EXPANDED_WIDTH = '280px'
export const GRAPH_WIDTH = 240
export const GRAPH_HEIGHT = 80

export const formatBytes = (bytes: number) => {
  if (bytes >= 1024 * 1024 * 1024)
    return `${(bytes / (1024 * 1024 * 1024)).toFixed(2)} GB`
  if (bytes >= 10 * 1024 * 1024)
    return `${Math.round(bytes / (1024 * 1024))} MB`
  if (bytes >= 1024 * 1024) return `${(bytes / (1024 * 1024)).toFixed(1)} MB`
  if (bytes >= 1024) return `${Math.round(bytes / 1024)} KB`
  return `${bytes} B`
}

export const formatFps = (fps: number) => `${Math.round(fps)} fps`

export const formatPercent = (percent: number) => {
  if (percent >= 1) return `${Math.round(percent)}%`
  if (percent > 0) return `${percent.toFixed(2)}%`
  return '0%'
}
